import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-16">
        <Breadcrumb />
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}